import { render, staticRenderFns } from "./ProductAmountModeSectionContainer.vue?vue&type=template&id=6848098f&"
import script from "./ProductAmountModeSectionContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductAmountModeSectionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports